import app from "app.controller"
import React, { Component } from 'react'
import { Link } from "react-router"

export default class ThemenPage extends Component {


  state = {
    menu:       [],
    themepages: [],
    pages:      []
  }

  loadPage = ( { slug } ) => {
    const { currentLanguage = "de" } = app
    fetch( `https://shop.mags-vertrieb.de/wp/wp-json/wp/v2/pages?slug=${slug}&lang=${currentLanguage}` )
      .then( res => res.json() )
      .then( page => {
        console.log( { page } )
        this.setState( {
          pages: [ ...this.state.pages, ...page ]
        } )
      } )

  }

  componentDidMount() {
    fetch( "https://shop.mags-vertrieb.de/wp/wp-json/acf/v3/menu?fields[name]=menu-en&lang=" + app._currentLanguage )
      .then( res => res.json() )
      .then( menus => menus[ 0 ] )
      .then( ( layout ) => {
        let themepages = layout.acf.menu.filter( entry => entry.isThemepage )
        let promises = themepages.map( theme => {
          return theme.links.map( page => {
            console.log( "R", { page } )
            page.url = addTrailingSlash( page.url )
            const slug = page.url.split( "/" ).slice( -2, -1 ).join( "" )
            console.log( "SLUG", page.url, page.url.split( "/" ), slug )
            this.loadPage( { slug } )
          } )
        } )
        this.setState( { themepages, menu: layout.acf.menu } )
      } )
  }

  render() {
    const { pages } = this.state
    return <div>
      <section className="container pt3">
        <div className="row-title">
          <div className="h2"><h2>{translate("Themenwelten")}</h2></div>
        </div>

        <div className="pages flex flex-wrap">
          {pages.map( page => {
            return <Page className={"w-50-ns pa3-ns"} key={page.id} page={page}/>
          } )
          }
        </div>
      </section>
    </div>
  }

}

ThemenPage.propTypes = {
  params:   React.PropTypes.object,
  filter:   React.PropTypes.object,
  location: React.PropTypes.object
}

const addTrailingSlash = url => {
  return url.replace( /\/?$/, '/' );
}


const Page = ( { page, className = "" } ) => {
  let image = false
  try {
    image = page.acf.layout[ 0 ].content[ 0 ].img
  } catch ( err ) {
    console.warn( "No image set for page", page )
  }

  return <div key={page.id} className={`${className}`}>
   <Link to={`/cms/${page.slug}`}>
     <h2 dangerouslySetInnerHTML={{ __html: page.title.rendered }}></h2>
     {image && <img src={image} alt=""/>}
   </Link>
  </div>
}


// WEBPACK FOOTER //
// ./src/pages/ThemenPage.js